export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14088.130a9f26.jpg";